module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Layout/Layout-top-panel-4-3f3f3b3b0c68a079723004f6aec22529.svg";